<template lang="pug">
  div.stamp(:style="`padding: ${stampPadding}`")
    v-icon(size="18" color="success500") $yzi-check
</template>

<script>
export default {
  props: {
    paddingTop: {
      type: String,
      default: '3px'
    },
    paddingBottom: {
      type: String,
      default: '3px'
    },
    paddingLeft: {
      type: String,
      default: '6px'
    },
    paddingRight: {
      type: String,
      default: '6px'
    },
  },
  computed: {
    stampPadding () {
      return `${this.paddingTop} ${this.paddingRight} ${this.paddingBottom} ${this.paddingLeft}`
    }
  },
}
</script>

<style scoped>
.stamp {
  width: 35px;
  height: 35px;
  border-radius: 50% !important;
  border: 2px #259143 solid;
}
</style>